import { Link } from "react-router-dom";

export default function ShopRules() {
  return (
    <>
      <div className="header-menu-wrapper">
        <div className="header">
          <div className="row w-100 h-25 ps-5 pe-5 me-5">
            <ul className="header-menu">
              <li>
                <Link className="item-link" to="/">
                  صفحه اصلی
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div className="container">
            <div className="content-description rules-on-shop">
              <h1>قوانین و مقررات​​​​​​​</h1>
              حریم خصوصی فروشگاه طلایی شو با تاکید بر احترامی که برای حریم شخصی
              کاربران قائل است، جهت خرید، ثبت نظر یا استفاده از برخی امکانات
              وبسایت اطلاعاتی را از کاربران درخواست میکند تا بتواند خدماتی امن و
              مطمئن را ارائه دهد. بدین منظور اطلاعاتی مانند نام و نام خانوادگی،
              کد ملی، آدرس، شماره تلفن و ایمیل مورد نیاز است و از آنجا که کلیه
              فعالیتهای فروشگاه طلایی شو مبتنی بر قوانین تجارت الکترونیک کشور
              صورت میگیرد و جهت کلیه خریدهای مشتریان صورتحساب صادر می¬شود. لذا
              ثبت اطلاعاتی مانند نام و کد ملی برای اشخاص حقیقی و کد اقتصادی و
              شناسه ملی برای اشخاص حقوقی الزامی است. یادآوری میشود تنها آدرس
              ایمیل و تلفنهایی که مشتری در پروفایل خود ثبت نموده است، مورد تایید
              طلایی شو بوده و کلیه مکاتبات از این طریق صورت می¬پذیرد. در این
              خصوص:
              <ol>
                <li>
                  در صورتی که اطلاعات مذکور به صورت صحیح یا کامل درج نشده باشد،
                  فروشگاه طلایی شو جهت اطمینان از صحت و قطعیت ثبت سفارش میتواند
                  از مشتری، اطلاعات تکمیلی و بیشتری درخواست نماید.
                </li>
                <li>
                  مشتریان میتوانند نام، آدرس و تلفن شخص دیگری را برای تحویل
                  گرفتن سفارش وارد کنند و فروشگاه طلایی شو تنها برای ارسال همان
                  سفارش، از این اطلاعات استفاده خواهد کرد.
                </li>
                <li>
                  مسئولیت هرگونه خسارت احتمالی ناشی از عدم ارائه اطلاعات صحیح و
                  دقیق به عهده کاربر بوده و کاربر حق هر گونه ادعایی علیه فروشگاه
                  طلایی شو را نخواهد داشت. فروشگاه طلایی شو هویت شخصی کاربران را
                  محرمانه دانسته و اطلاعات شخصی ایشان را به هیچ شخص یا سازمان
                  دیگری منتقل نمیکند، مگر اینکه با حکم مقام قضایی یا اداری صالحه
                  یا حسب قوانین و مقررات رایج کشور موظف باشد در اختیار مراجع
                  ذیصلاح قرار دهد.در این موارد هیچ گونه مسئولیت قانونی مبنی بر
                  جبران خسارت برای فروشگاه طلایی شو وجود ندارد و کاربران با
                  اعلام رضایت خود در استفاده از خدمات وب سایت حق هرگونه اعتراض
                  را از خود سلب نموده اند.
                </li>
                <li>
                  فروشگاه طلایی شو برای حفاظت و نگهداری اطلاعات و حریم شخصی
                  کاربران همه توان خود را به کار میگیرد و امیدوار است که تجربه
                  خریدی امن، راحت و خوشایند را برای همه کاربران فراهم آورد.
                </li>
                <li>
                  همه مطالب سایت فروشگاه طلایی شو ، مانند متن، گرافیک، آرم،
                  آیکون دکمه، تصاویر، ویدئوهای تصویری، موارد قابل دانلود و کپی،
                  دادهها و کلیه محتوای تولید شده توسط فروشگاه طلایی شو جزئی از
                  دارایی های این فروشگاه محسوب و حق استفاده و نشر تمامی مطالب
                  موجود و در دسترس در انحصار طلایی شو است و هرگونه استفاده بدون
                  کسب مجوز کتبی، حق پیگرد قانونی را برای فروشگاه طلایی شو محفوظ
                  می کند.
                </li>
              </ol>
              <p>ثبت، پردازش و ارسال سفارش</p>
              <ol>
                <li>
                  کلیه سفارش‏های ثبت شده در سایت فروشگاه طلایی شو بعد از ارسال
                  کد سفارش از طریق پیام کوتاه برای مشتری در صف پردازش قرار
                  میگیرند. با وجود این، در صورتی که موجودی محصولی به پایان برسد،
                  حتی پس از اقدام به سفارش‏گذاری مشتری، حق کنسل کردن آن سفارش و
                  یا استرداد وجه سفارش برای فروشگاه طلایی شو محفوظ است.
                </li>
                <li>
                  پردازش سفارشات انجام شده در روزهای کاری از روز شنبه تا پنج
                  شنبه هر هفته، به استثنای تعطیلات عمومی در ایران انجام می¬شود و
                  کلیه سفارشات‏ ثبت شده در اولین روز کاری بعد و یا اولین روز پس
                  از تعطیلات پردازش می‏شوند. فروشگاه طلایی شو به مشتریان خود در
                  7 روز هفته و 24 ساعت شبانه روز امکان سفارش‏ گذاری می‏دهد.
                </li>
                <li>
                  فروشگاه طلایی شو مجاز است بدون اطلاع قبلی نسبت به توقف
                  سفارش‏گیری جدید، اقدام و فروش خود را متوقف کند و کلیه
                  سفارش‏های ثبت شده قبل از توقف سفارش‏گیری، پردازش و ارسال
                  می‏شود. حق قطع فروش کلیه و یا بخشی از محصولات به هر دلیلی
                  مانند اتمام موجودی کالا بدون اطلاع قبلی، برای فروشگاه طلایی شو
                  محفوظ است
                </li>
                <li>
                  کلیه فروش های سایت فروشگاه طلایی شو به صورت نقدی بوده و کلیه
                  وجه محصول هنگام ثبت سفارش دریافت میگردد.
                </li>
                <li>
                  در صورت بروز هرگونه خطا نسبت به درج قیمت و ارزش ریالی کالاهای
                  موجود در سایت ، حق بلا اثر نمودن سفارش و خرید انجام شده توسط
                  مشتری، برای فروشگاه طلایی شو محفوظ است. فروشگاه طلایی شو وجوه
                  دریافتی را طی 24 الی 48 ساعت کاری به حساب اعلام شده توسط مشتری
                  واریز و عودت مینماید و خرید مشتری از سایت به منزله پذیرش موارد
                  یاد شده می¬باشد.
                </li>
                <li>
                  با توجه به ثبت سیستمی سفارش، به هیچ عنوان امکان اصلاح فاکتور
                  از جمله هرگونه تغییر در مشخصات آن وجود ندارد. بنابراین لازم
                  است مشتریان هنگام ثبت سفارش، نسبت به این مساله دقت لازم را
                  داشته باشند.
                </li>
                <li>
                  سفارش مشتری صرفاً به نشانی اعلام شده ارسال می¬گردد. تحویل
                  سفارش در اماکن عمومی همچون کافه، کافی نت، رستوران، هتل و مانند
                  آن امکانپذیر نمی¬باشد.(در حال حاضر برای تعدادی از محصولات فعال
                  است)
                </li>
                <li>
                  افزودن کالا به سبد خرید به معنی رزرو کالا نیست و هیچ گونه حقی
                  را برای مشتریان ایجاد نمیکند. همچنین تا پیش از ثبت نهایی،
                  هرگونه تغییر از جمله تغییر در موجودی کالا یا قیمت، روی کالای
                  افزوده شده به سبد خرید اعمال خواهد شد.
                </li>
                <li>
                  تاریخ ارسال سفارشاتی که نحوه تحویل آن، پستی انتخاب شده است
                  حداکثر 7 روز کاری بعد خواهد بود. مگر در مواردی مانند
                  محدودیت¬های کرونایی که تأخیر در ارسال از طریق وبسایت اطلاع
                  رسانی خواهد شد.خرید های اعتباری طی 5 روز کاری و پس از تسویه
                  مبلغ فاکتور توسط ارائه دهنده اعتبار فدکس ارسال می گردد.
                </li>
                <li>
                  فروشگاه طلایی شو متعهد است، پس از ثبت سفارش و ارسال تاییدیه به
                  مشتری، با رعایت سیاست های معین ارسال کالا (اخذ هزینه¬های
                  مربوطه به تحویل)، سفارش را در مکان مورد انتخاب خریدار تحویل
                  نماید. در صورت عدم حضور سفارش دهنده در مکان و زمان تعیین شده،
                  خریدار موظف است هزینه¬های مربوطه به تحویل مجدد را پرداخت
                  نماید.(در حال ارسال حاضر برای تعدادی از محصولات فعال است)
                </li>
                <li>
                  فروشگاه طلایی شو همواره نهایت تلاش خود را می‏کند تا کلیه
                  سفارش‏ها در نهایت صحت و بدون آسیب به دست مشتریان در سراسر کشور
                  برسد. با توجه به بسته بندی ایمن و استاندارد همه مرسولات، تحویل
                  پست و اعلام بارنامه مرسوله (درج در سبد خرید و اطلاع رسانی از
                  طریق سرویس پیام کوتاه) به این معنی است که بروز هر گونه حادثه
                  در هنگام حمل و تحویل به عهده شرکت حمل و نقل است.(در حال حاضر
                  برای تعدادی از محصولات فعال است) قوه قهریه
                </li>
                <li>
                  تمامی شرایط و قوانین مندرج، در شرایط عادی قابل اجرا است و در
                  صورت بروز هرگونه از موارد قوه قهریه، مطابق با قوانین جاری کشور
                  عمل خواهد گردید. فروشگاه طلایی شو خود را ملزم به رعایت حریم
                  شخصی کاربران میداند، لطفا در صورت مشاهده هرگونه تخلف، مراتب را
                  از طریق کانال‏های ارتباطی ذکر شده با ما در میان بگذارید. خرید
                  اقساطی
                </li>
                <li>
                  از آنجایی که تمام محصولات فروشگاه طلایی شو 24 عیار می باشند
                  تحویل شمش ها ( پارسیس یا زیوتو ) بر اساس موجودی انبار و به
                  انتخاب فروشگاه طلایی شو می باشد. 14.هرگونه تغییر در قوانین،
                  شرط های استفاده از خدمات، کارمزدها و مقررات حقوقی ، از طریق
                  سایت صفحه قوانین و مقررات بروز رسانی می شود و خرید از طلایی شو
                  به منزله پذیرش تمامی قوانین و مقررات فروشگاه طلایی شو می باشد.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
